var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('div',{attrs:{"id":"loading-center"}},[_c('img',{staticStyle:{"max-width":"90%","width":"600px"},attrs:{"src":require('../../assets/images/animated_logo.gif')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }